var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSochrim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 23,
    viewBox: "0 0 14 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#36947D",
    d: "M6.948 6.764l-1.755-.05c-.536-.015-.978.417-.978.955v13.193c0 .528.426.956.95.956h1.756c.524 0 .95-.428.95-.956V7.72c0-.517-.409-.94-.923-.955M5.413 19.766c-.254 0-.46-.207-.46-.462 0-.254.206-.461.46-.461.253 0 .46.207.46.461 0 .255-.207.462-.46.462m0-1.517c-.254 0-.46-.207-.46-.462 0-.256.206-.462.46-.462.253 0 .46.206.46.462 0 .255-.207.462-.46.462m0-1.518c-.254 0-.46-.207-.46-.462 0-.254.206-.461.46-.461.253 0 .46.207.46.461 0 .255-.207.462-.46.462",
    transform: "translate(.61 .972)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A6354",
    d: "M10.448 0h-8.81C.738 0 0 .742 0 1.648v5.204c0 .906.737 1.647 1.638 1.647h8.81c.901 0 1.639-.741 1.639-1.647V1.648C12.087.742 11.349 0 10.448 0zm-1.7 2.704c0 .316-.257.576-.572.576H3.91c-.315 0-.572-.26-.572-.576v-.789c0-.316.257-.575.572-.575h4.265c.315 0 .572.26.572.575v.79z",
    transform: "translate(.61 .972)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSochrim);
export default __webpack_public_path__ + "static/media/sochrim.7380858636c3b7e7b3e116708a4d1b09.svg";
export { ForwardRef as ReactComponent };